import React, { useState, useEffect } from "react";
import {
  Dialog,
  ButtonVariant,
  TextField,
  TextFieldVariant,
} from "@merge-api/merge-javascript-shared";
import { ORGANIZATION_NAME_MAX_LENGTH } from "../../../../../constants";

type Props = {
  onHandleNameChange: (name: string) => void;
  isShown: boolean;
  onHide: () => void;
  currentName: string;
};

const EditOrganizationNameModal = ({ onHandleNameChange, isShown, onHide, currentName }: Props) => {
  // STATE
  const [name, setName] = useState<string>(currentName);

  // DERIVED STATE
  // Validate and submit the trimmed name so whitespace-only input can't save,
  // matching the signup paths and the backend, which trims before validating.
  const trimmedName = name.trim();
  const isNameEmpty = trimmedName.length < 1;
  const isNameTooLong = trimmedName.length > ORGANIZATION_NAME_MAX_LENGTH;
  const error = isNameEmpty || isNameTooLong;
  const errorText = isNameEmpty
    ? "Organization name is required"
    : isNameTooLong
    ? `Organization name must be ${ORGANIZATION_NAME_MAX_LENGTH} characters or fewer`
    : undefined;

  // Reset name when dialog opens
  useEffect(() => {
    if (isShown) {
      setName(currentName);
    }
  }, [isShown, currentName]);

  return (
    <Dialog
      open={isShown}
      onClose={onHide}
      variant="md"
      title="Edit organization name"
      primaryButtonText="Save"
      primaryButtonVariant={ButtonVariant.PrimaryGray}
      primaryButtonDisabled={error}
      onPrimaryButtonClick={() => onHandleNameChange(trimmedName)}
      secondaryButtonText="Cancel"
      secondaryButtonVariant={ButtonVariant.TextBlack}
      onSecondaryButtonClick={onHide}
    >
      <TextField
        labelTitle="Organization name"
        variant={TextFieldVariant.Shadowed}
        placeholder="Enter name"
        value={name}
        maxLength={ORGANIZATION_NAME_MAX_LENGTH}
        onChange={(e) => setName(e.target.value)}
        error={error}
        errorText={errorText}
      />
    </Dialog>
  );
};

export default EditOrganizationNameModal;
